import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

import "./AddTestModal.css";

export default function SampleExitModal({
  setExitModal,
  handleGoBackToMainPage,
  headerText,
  bodyText,
}) {
  const onCancel = () => {
    setExitModal(false);
  };
  return (
    <Modal
      open
      closable
      centered
      footer={null}
      width="448px"
      wrapClassName="ConfirmModal"
      className="ConfirmModal"
      closeIcon={<CloseOutlined className="SampleSubmissionModal__closeIcon" />}
      onCancel={onCancel}
    >
      <div className="AddTestConfirmDel">
        <div className="AddTestConfirmDelTitle">{headerText}</div>
        <div className="AddTestConfirmDelTitleMessage">{bodyText}</div>
        <div className="AddTestConfirmDelBtn">
          <Button
            type="default"
            onClick={() => {
              setExitModal(false);
              handleGoBackToMainPage();
            }}
          >
            Leave
          </Button>
          <Button
            type="primary"
            onClick={onCancel}
          >
            Stay
          </Button>
        </div>
      </div>
    </Modal>
  );
}
